<template>
   
    <div id="app" >
      <!--<Menu></Menu>-->
      <router-view/>
      <!--<Login></Login>-->
    </div>
    
</template>
<script>
//import Menu from './components/Menu.vue'
//import NuevoProyecto from './components/Proyectos/NuevoProyecto.vue'
//import Login from './components/Login.vue'
//import Hello from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    //Menu,
    //NuevoProyecto
    //Login
  }
  
}
</script>
<style>
@font-face {
  font-family: "Ds-digital";
  src: local("Ds-Digital"),   
  url(../public/fonts/ds-digital/DS-DIGI.TTF) format("truetype");
  }
  </style>